import { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import { api } from '../api';
import Icon from './Icon';

const NAV = [
  { label: 'Command', items: [
    { to: '/', icon: 'grid', label: 'Live overview', end: true },
    { to: '/battles', icon: 'sword', label: 'Battles archive' },
  ]},
  { label: 'Intelligence', items: [
    { to: '/clan-stats', icon: 'shield', label: 'Clan room' },
    { to: '/search', icon: 'users', label: 'Player finder' },
  ]},
  { label: 'World', items: [
    { to: '/top50', icon: 'trophy', label: 'Global ranking' },
    { to: '/global-clans', icon: 'globe', label: 'Clan directory' },
  ]},
];

export default function Sidebar({ wsConnected, mobileOpen, onMobileClose }) {
  const { theme, toggle } = useTheme();
  const [stats, setStats] = useState(null);
  const location = useLocation();

  useEffect(() => {
    api.stats().then(setStats).catch(() => {});
  }, []);

  // Close mobile sidebar on route change
  useEffect(() => { onMobileClose(); }, [location, onMobileClose]);

  return (
    <nav className={`sidebar${mobileOpen ? ' open' : ''}`}>
      <div className="sidebar-logo">
        <span className="sidebar-logo-icon"><Icon name="sword" size={18} /></span>
        <span>
          <span className="sidebar-logo-text">Battleboard</span>
          <span className="sidebar-logo-kicker">Clan intelligence</span>
        </span>
      </div>

      <div className="nav-links">
        {NAV.map(section => (
          <div className="nav-section" key={section.label}>
            <div className="nav-section-label">{section.label}</div>
            {section.items.map(({ to, icon, label, end }) => (
              <NavLink key={to} to={to} end={end}
                className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>
                <span className="nav-icon"><Icon name={icon} size={17} /></span>{label}
              </NavLink>
            ))}
          </div>
        ))}
      </div>

      <div className="sidebar-footer">
        {stats && (
          <div className="sidebar-stats">
            <div className="sidebar-stat"><strong>{stats.battles}</strong> Battles</div>
            <div className="sidebar-stat"><strong>{stats.clans}</strong> Clans &nbsp;·&nbsp; <strong>{stats.players}</strong> Players</div>
          </div>
        )}
        <div className="ws-row">
          <div className={`ws-dot${wsConnected ? ' connected' : ''}`} />
          <span className="ws-label">{wsConnected ? 'Live updates' : 'Reconnecting…'}</span>
        </div>
        <button className="theme-btn" onClick={toggle}>
          <Icon name={theme === 'dark' ? 'sun' : 'moon'} size={16} />
          {theme === 'dark' ? 'Light interface' : 'Dark interface'}
        </button>
      </div>
    </nav>
  );
}
